/**
 * Created by tofaelraju on 10/15/17.
 */

import React from 'react';
import {Link} from 'react-router';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';

const styles={
  color: '#ffffff',
  fontFamily:'Roboto'
}

const DrawerMenu = ({menus})=>(
  <Menu>
    {menus.map((menu, index) =>
      <MenuItem
        value={index}
        containerElement={<Link to={menu.link}/>}
        leftIcon={menu.icon}
        style={styles}
        hoverColor="transparent"
        primaryText={menu.text}
        key={index}
      />
    )}
  </Menu>
);

export default DrawerMenu;


// WEBPACK FOOTER //
// ./src/screens/layout/menu.js